export enum RolesEnum {
  DEFAULT = 'default',
  USER = 'user',
  ADMIN = 'admin'
}
